var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#F09A0FFF",
        height: "20px",
        width: "20px",
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 489.8 489.8",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M179.2,453.2c21.3,5.2,43.4,7.9,65.7,7.9c135.1,0,244.9-97,244.9-216.2S380,28.7,244.9,28.7S0,125.7,0,244.9 c0,47.1,17.6,93.2,49.7,130.6C43,390.3,33.2,402,20.4,410.3c-6.6,4.3-9.8,12.1-8.1,19.8c1.7,7.6,7.8,13.2,15.5,14.3 c20.4,2.8,60.1,4.3,96.9-17.7c5.8-3.5,7.7-11,4.2-16.8c-3.5-5.8-11-7.7-16.8-4.2c-23,13.8-47.9,16.4-66,15.8 c12.9-11.6,22.7-26.3,29.3-44c1.6-4.3,0.6-9.2-2.5-12.6c-31.7-34.5-48.4-75.9-48.4-120c0-105.7,98.9-191.7,220.4-191.7 s220.4,86,220.4,191.7s-98.9,191.7-220.4,191.7c-20.3,0-40.5-2.4-59.9-7.2c-6.6-1.6-13.2,2.4-14.8,9S172.6,451.6,179.2,453.2z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M169.7,335.2c1.9,1.1,4,1.6,6,1.6c4.3,0,8.4-2.2,10.7-6.2c10.9-19.2,33.9-31.6,58.8-31.6c25,0,47.5,11.9,58.6,31.1 c3.4,5.9,10.9,7.9,16.7,4.5c5.9-3.4,7.9-10.9,4.5-16.7c-15.5-26.8-46.1-43.4-79.8-43.4c-34.1,0-64.8,16.9-80.1,44 C161.7,324.4,163.8,331.9,169.7,335.2z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M146,241.1c2.3,3.8,6.3,5.9,10.5,5.9c2.2,0,4.3-0.6,6.3-1.8l56.3-34c3.9-2.4,6.2-6.7,5.9-11.2c-0.3-4.6-3.1-8.6-7.2-10.4 L160.4,164c-6.2-2.8-13.4,0-16.2,6.2s0,13.4,6.2,16.2l36,16.1l-36.2,21.8C144.3,227.8,142.5,235.3,146,241.1z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M345.7,170.2c-2.8-6.2-10-8.9-16.2-6.2l-57.4,25.6c-4.2,1.9-7,5.9-7.2,10.4c-0.3,4.6,2,8.9,5.9,11.2l56.3,34 c2,1.2,4.2,1.8,6.3,1.8c4.1,0,8.2-2.1,10.5-5.9c3.5-5.8,1.6-13.3-4.2-16.8l-36.2-21.8l36-16.1 C345.7,183.6,348.5,176.4,345.7,170.2z",
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }